import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const WaterUtilityOutlinedIcon:FC<SvgIconProps> = (props) => (
  <SvgIcon
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M1.8335 11.3332V1.3332H5.1671V11.3332H8.5003V7.1668C8.50024 6.72904 8.58642 6.29557 8.75391 5.89112C8.92139 5.48667 9.1669 5.11917 9.47643 4.80961C9.78595 4.50005 10.1534 4.2545 10.5578 4.08696C10.9623 3.91943 11.3957 3.8332 11.8335 3.8332H16.0003V7.1668H11.8335V11.3332C11.8335 11.771 11.7474 12.2044 11.5799 12.6089C11.4124 13.0133 11.1669 13.3808 10.8574 13.6904C10.5478 13.9999 10.1804 14.2455 9.77595 14.413C9.37152 14.5806 8.93805 14.6668 8.5003 14.6668H5.1671C4.72931 14.6669 4.29579 14.5807 3.89132 14.4132C3.48685 14.2456 3.11933 14.0001 2.80977 13.6905C2.5002 13.381 2.25465 13.0134 2.08714 12.609C1.91963 12.2045 1.83344 11.771 1.8335 11.3332Z"

      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.00024 1.3332H1.00024M16.0002 8V3"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
)
